import api from './api';

const configurationService = {
  /**
   * Obtener todas las configuraciones
   */
  async getAll(params = {}) {
    try {
      const response = await api.get('/configuration', { params });
      return {
        success: true,
        data: response.data.data
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Error al obtener configuraciones'
      };
    }
  },

  /**
   * Obtener configuración específica
   */
  async get(categoria, clave) {
    try {
      const response = await api.get(`/configuration/${categoria}/${clave}`);
      return {
        success: true,
        data: response.data.data
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Error al obtener configuración'
      };
    }
  },

  /**
   * Actualizar configuración
   */
  async update(categoria, clave, valor) {
    try {
      const response = await api.put(`/configuration/${categoria}/${clave}`, {
        valor: String(valor)
      });
      return {
        success: true,
        data: response.data.data,
        message: response.data.message
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Error al actualizar configuración'
      };
    }
  },

  /**
   * Crear configuración
   */
  async create(data) {
    try {
      const response = await api.post('/configuration', data);
      return {
        success: true,
        data: response.data.data,
        message: response.data.message
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Error al crear configuración'
      };
    }
  },

  /**
   * Obtener categorías
   */
  async getCategories() {
    try {
      const response = await api.get('/configuration/categories');
      return {
        success: true,
        data: response.data.data
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Error al obtener categorías'
      };
    }
  },

  /**
   * Helper: Obtener configuraciones de ventas en formato objeto
   * @returns {Promise<Object>} Objeto con las configuraciones indexadas por clave
   */
  async getSalesConfiguration() {
    try {
      const response = await api.get('/configuration?categoria=ventas');
      
      // Convertir array a objeto para fácil acceso
      const config = {};
      response.data.data.forEach(item => {
        config[item.clave] = {
          valor: item.valor,
          tipo: item.tipo,
          descripcion: item.descripcion,
          esEditable: item.esEditable
        };
      });
      
      return { success: true, data: config };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Error al obtener configuración de ventas'
      };
    }
  },

  /**
   * Helper: Actualizar múltiples configuraciones de ventas en batch
   * @param {Object} configs - Objeto con las configuraciones a actualizar
   * @returns {Promise<Array>} Array de resultados
   */
  async updateSalesConfiguration(configs) {
    try {
      const promises = Object.entries(configs).map(([clave, valor]) => 
        this.update('ventas', clave, valor)
      );
      
      const results = await Promise.all(promises);
      
      // Verificar si todas las actualizaciones fueron exitosas
      const allSuccess = results.every(result => result.success);
      
      return {
        success: allSuccess,
        results,
        message: allSuccess 
          ? 'Todas las configuraciones se actualizaron correctamente'
          : 'Algunas configuraciones no se pudieron actualizar'
      };
    } catch (error) {
      return {
        success: false,
        message: 'Error al actualizar configuraciones de ventas'
      };
    }
  },

  /**
   * Helper: Generar vista previa del próximo número de venta
   * @param {Object} config - Objeto con prefijo, formato y numero_actual
   * @returns {string} Vista previa del número
   */
  generatePreview(config) {
    const { 
      prefijo = 'V', 
      formato = '{prefijo}{año}{mes}{dia}-{numero:04d}', 
      numero_actual = '1' 
    } = typeof config === 'string' ? { prefijo: config, formato: arguments[1] } : config;
    
    const ahora = new Date();
    const año = ahora.getFullYear();
    const mes = String(ahora.getMonth() + 1).padStart(2, '0');
    const dia = String(ahora.getDate()).padStart(2, '0');

    let preview = formato
      .replace('{prefijo}', prefijo)
      .replace('{año}', año)
      .replace('{mes}', mes)
      .replace('{dia}', dia);

    // Procesar formatos de número con padding
    const numeroMatch = formato.match(/\{numero:(\d+)d\}/);
    if (numeroMatch) {
      const padding = parseInt(numeroMatch[1]);
      const numeroFormateado = String(numero_actual).padStart(padding, '0');
      preview = preview.replace(/\{numero:\d+d\}/, numeroFormateado);
    } else {
      preview = preview.replace('{numero}', numero_actual);
    }

    return preview;
  }
};

export default configurationService;

